export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "isiparyaj-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "isiparyaj-themeWrapLive" */'./LiveThemeImporter'),
  },
};
